"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_79)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_79`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#0052B4"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_79`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GAFlag };
